import Skeleton from '../skeleton/Skeleton';
import ThreadListItemSkeleton from './ThreadListItemSkeleton';
import {
  StyledContentHolder,
  StyledEmailMessages,
  StyledFilterSidebar,
  StyledThreePaneGrid,
  StyledUniboxHeader,
  StyledUniboxPage,
} from './Unibox.styles';

/** Row counts per rail group: channels, statuses, campaigns, accounts. */
const RAIL_GROUPS = [3, 6, 4, 4];

/**
 * The whole inbox's shape — header, filter rail, thread list and conversation —
 * built from the page's own wrappers, shown until all of it can appear at once.
 */
const UniboxSkeleton = () => (
  <StyledUniboxPage aria-busy="true">
    <StyledUniboxHeader>
      <div className="header-row">
        <div>
          <Skeleton width={120} height={28} radius="8px" resp />
          <Skeleton width={360} height={14} radius="6px" margin="10px 0 0" resp />
        </div>
        <Skeleton width={220} height={40} radius="18px" resp />
      </div>
    </StyledUniboxHeader>

    <StyledThreePaneGrid>
      <StyledFilterSidebar>
        <Skeleton width="100%" height={36} radius="14px" />
        {RAIL_GROUPS.map((rows, group) => (
          <div key={`rail-group-${group}`}>
            <div className="rail-divider" />
            {group > 0 && <Skeleton width={64} height={10} radius="6px" margin="0 4px 8px" />}
            <div className="rail-group">
              {Array.from({ length: rows }, (_, row) => (
                <Skeleton key={`rail-row-${group}-${row}`} width="100%" height={32} radius="14px" />
              ))}
            </div>
          </div>
        ))}
      </StyledFilterSidebar>

      <div className="panes">
        <StyledContentHolder>
          <div className="emails-sidebar">
            <div className="thread-pane-head">
              <Skeleton width={80} height={14} radius="6px" />
              <Skeleton width={64} height={14} radius="6px" />
            </div>
            <div className="col-holder">
              <div className="threads-skeleton">
                {Array.from({ length: 10 }, (_, index) => (
                  <ThreadListItemSkeleton key={index} />
                ))}
              </div>
            </div>
          </div>
        </StyledContentHolder>

        <StyledEmailMessages>
          <div className="conversation-head">
            <Skeleton width="70%" height={48} />
          </div>
          <div className="messages-wrapper">
            <div className="messages-holder">
              <div className="transcript-stack">
                {Array.from({ length: 3 }, (_, index) => (
                  <Skeleton key={index} width="100%" height={120} />
                ))}
              </div>
            </div>
            <div className="input-holder">
              <Skeleton width="100%" height={140} />
            </div>
          </div>
        </StyledEmailMessages>
      </div>
    </StyledThreePaneGrid>
  </StyledUniboxPage>
);

export default UniboxSkeleton;
